import { memo } from 'react';
import { Autocomplete, AutocompleteProps, LoadScriptNext } from '@react-google-maps/api';
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import React from 'react';

export const googleMapsLibraries: Libraries = ['places'];

let mapIsLoaded: boolean = false;

// eslint-disable-next-line react/display-name
export const LoadGoogleMap = memo((props: { googleMapsApiKey: string, onLoaded?: (isLoaded: boolean | Error | undefined) => void }) => {

    React.useEffect(() => {
        if (props.googleMapsApiKey) {
            mapIsLoaded = false;
        }
        return () => {
            mapIsLoaded = false;
        }
    }, [])
    return <div style={{ display: 'none' }}>
        <LoadScriptNext
            googleMapsApiKey={props.googleMapsApiKey}
            libraries={googleMapsLibraries}
            onLoad={() => { props.onLoaded?.(true); mapIsLoaded = !!props.googleMapsApiKey; }}
            onUnmount={() => { mapIsLoaded = false }}
            onError={() => { mapIsLoaded = false }}
            language='en'
        >
            <></>
        </LoadScriptNext>
    </div>
}, (props, nextProps) => {
    return props.googleMapsApiKey === nextProps.googleMapsApiKey
})

export function StandaloneSearchBoxComponent(props: AutocompleteProps & { children: JSX.Element, googleMapsApiKey: string }) {
    return (
        <div style={{ height: '100%', width: '100%' }}>
            {
                (mapIsLoaded && props.googleMapsApiKey)
                    ?
                    <Autocomplete
                        options={{}}
                        {...props}
                    />
                    :
                    <div>
                        {props.children}
                    </div>
            }
        </div>
    )
}